import http, { expandURI } from '@/utils/ajax'
import { TOTALQI_INIT_LOADING, TOTALQI_INIT_SUCCESS, TOTALQI_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  totalQuotationsIssued: {
    init: 0,
    menu: {},
    noQuote: null,
    lastUpdated: null,
    scope: null,
    info: null,
    appIds: []
  }
}

const getters = {

}

const actions = {
  async initTotalQuotationsIssued({ commit, state }, data) {
    commit(TOTALQI_INIT_LOADING)
    const apiUrl = state.permitWidgets.totalQuotationsIssued
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to)
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)
        Object.assign(data, {
          menu: menu,
          noQuote: result.data.noQuote,
          info: result.data.info,
          appIds: result.data.appIds
        })
        commit(TOTALQI_INIT_SUCCESS, data)
      } catch (error) {
        commit(TOTALQI_INIT_FAIL)
      }
    } else {
      commit(TOTALQI_INIT_FAIL)
    }
  }
}

const mutations = {
  [TOTALQI_INIT_LOADING](state) {
    state.totalQuotationsIssued.init = 0
  },
  [TOTALQI_INIT_SUCCESS](state, data) {
    const { totalQuotationsIssued } = state
    totalQuotationsIssued.menu = data.menu
    totalQuotationsIssued.init = 1
    totalQuotationsIssued.lastUpdated = new Date()
    totalQuotationsIssued.scope = data.scope
    totalQuotationsIssued.noQuote = data.noQuote
    totalQuotationsIssued.info = data.info
    totalQuotationsIssued.appIds = data.appIds
  },
  [TOTALQI_INIT_FAIL](state) {
    state.totalQuotationsIssued.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
